import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useRtl } from "@ryde/redux";
import { IEtlViewLogsDrawerProps, IInjectedDrawerProps } from "@ryde/shared";

import { CommonDefaultDrawer } from "../../common-default-drawer";
import { BaseDrawer, FormFooter } from "../../drawer";
import { RichLogsFormWrapper } from "../rich-logs-components";
import { RichLogsHeader } from "../rich-logs-components/rich-logs.header";
import { EtlLogsContent, EtlViewLogsDrawerWrapperStyled } from "./parts";

export const EtlViewLogsDrawer: FC<
  IEtlViewLogsDrawerProps & IInjectedDrawerProps
> = ({ drawerNumber, onCloseDrawer, logsFormWatched }) => {
  const { t } = useTranslation();
  const { isRtl } = useRtl();

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <RichLogsFormWrapper logData={logsFormWatched}>
        <CommonDefaultDrawer
          onCloseDrawer={onCloseDrawer}
          Header={
            <RichLogsHeader
              onCloseDrawer={onCloseDrawer}
              entity="etlJobLog"
              isFinished={true}
              logsFormWatched={logsFormWatched}
              logsFromWatchedApiOld={[]}
            />
          }
          Footer={
            <FormFooter
              cancelLabel={t("general.CLOSE")}
              onCancelClick={onCloseDrawer}
            />
          }
        >
          <EtlViewLogsDrawerWrapperStyled $isRtl={isRtl}>
            {Boolean(logsFormWatched) && (
              <EtlLogsContent
                logData={logsFormWatched}
                hasExternalLogs={Boolean(logsFormWatched)}
              />
            )}
          </EtlViewLogsDrawerWrapperStyled>
        </CommonDefaultDrawer>
      </RichLogsFormWrapper>
    </BaseDrawer>
  );
};
